import styled from "@emotion/styled";
import { VariableSizeList } from "react-window";
export const VariableSizeListStyled = styled(VariableSizeList)`
    & > div {
        position: relative;
        margin: 8px 0;
    }
`;
//# sourceMappingURL=VariableSizeListStyled.js.map